/*eslint-disable */
import React, { Component } from "react";
import { Table, Icon, Button, Header } from "semantic-ui-react";
import DeleteModal from "../../../components/common/deleteModal";
import UserEdit from "../../../components/common/userEdit";
import { translate } from "react-i18next";
import { genericConstants } from "../../../utils/constant";

class AddUserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModel: false,
      deleteModalOpen: false,
      editUser: false,
      deleteId: "",
      editUserInputs: false,
      editParams: [],
      deleteuserID: "",
    };
  }
  openDeleteModal = (e, data) => {
    let u_id = data.u_id
    let username = data.username
    let realName = data.realName
    let email = data.email
    let password = data.password
    let mobileNo = data.mobileNo
    let params = [u_id, username, realName, email, mobileNo, password,businessUnitName];
    this.setState({
      deleteModalOpen: true,
      editParams: params
    })
  }
  editUserModal = (e, data) => {
    console.log(data);
    if (data.add_mode === 'add') {
      this.setState({
        editUser: true,
        editUserInputs: false,
        editParams: null,
      })
    } else if (data.add_mode === 'edit') {
      this.setState({
        editUser: true,
        editUserInputs: true,
        editParams: { ...data.user_items },
      })
    } else {
      this.setState({
        deleteId: data.user_items.u_id,
        deleteModalOpen: true,
        editParams: { ...data.user_items },
      })
    }
  }
  editUserModalClose = () => {
    this.setState({
      editUser: false,
      editUserInputs: false
    })
  }
  getCloseFeedback = (data) => {
    if (data) {
      this.setState({
        editUser: false,
        editUserInputs: false
      })
    }
  }
  closeDeleteModal = () => {
    this.setState({
      deleteModalOpen: false,
    });
  };
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Table
          stackable
          className="animated slideInDown"
          selectable
          size="small"
        >
          <Table.Header className="w3-small">
            <Table.Row>
              <Table.HeaderCell colSpan="6">
                <Header
                  as="label"
                  size="tiny"
                  color="black"
                  className="labelName p-bold-600"
                >
                  {t('title') || 'Users'}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan="2" textAlign="right">
                <Button
                  color="blue"
                  add_mode="add"
                  onClick={this.editUserModal}
                  size="mini"
                  type="button"
                >
                  <Icon name="plus" />  {t('add_title') || 'New'}
                </Button>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell className="p-bold-600">
                {t('table_header.user_name') || 'Username'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.name') || 'Name'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.email') || 'Email'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.phone') || 'Phone'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.business_unit') || 'Business Unit'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.edit') || 'Edit'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('table_header.delete') || 'Delete'}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.props.usersItems && this.props.usersItems.length > 0 ? (
              this.props.usersItems.map((object, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{object.userName}</Table.Cell>
                  <Table.Cell>{object.realName}</Table.Cell>
                  <Table.Cell>{object.email}</Table.Cell>
                  <Table.Cell>{object.mobileNo}</Table.Cell>
                  <Table.Cell>{object?.businessUnitName ? object?.businessUnitName : genericConstants.NA}</Table.Cell>
                  <Table.Cell><Button user_items={object} type="button" add_mode="edit" onClick={this.editUserModal} size="mini" color="green" basic icon> <Icon name="edit" /> </Button> </Table.Cell>
                  {/* <Table.Cell><VendorAlert id={object.u_id} editParams={object} /></Table.Cell> */}
                  <Table.Cell><Button type="button" user_items={object} add_mode="delete" onClick={this.editUserModal} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                </Table.Row>
              ))
            ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
          </Table.Body>
        </Table>
        <DeleteModal editParams={this.state.editParams} id={this.state.deleteId} productName={this.props.modalType} deleteOpen={this.state.deleteModalOpen} CloseModal={this.closeDeleteModal} />
        <UserEdit id={this.props.mainId} isBusinessUnit={this.props.isBusinessUnit} productName={this.props.modalType} editUser={this.state.editUser} editParams={this.state.editParams} editUserMode={this.state.editUserInputs} closeEditUser={this.getCloseFeedback} CloseModal={this.editUserModalClose} t={t} />
        
      </React.Fragment>
    );
  }
}
export default translate("user_table")(AddUserTable);
